import React from "react";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-main">
        <p>© {year} Flickerbound. All rights reserved.</p>
        <p className="footer-tagline">Fueling the imagination.</p>
      </div>

      <div className="footer-sitemap">
        <h4>Site Map</h4>
        <ul>
          <li><a href="/">Home</a></li>

          <li><a href="/shop">Shop</a></li>
          <li><a href="/shop/coloring-books">Coloring Books</a></li>
          <li><a href="/shop/journals">Journals</a></li>

          <li><a href="/blog">Blog</a></li>
          <li><a href="/about">About</a></li>
          <li><a href="/contact">Contact</a></li>

          {/* Legal Pages */}
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
          <li><a href="/refunds">Refund Policy</a></li>
          <li><a href="/shipping">Shipping Policy</a></li>
          <li><a href="/cookies">Cookie Notice</a></li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
